@if (isSearchVisible) {
  <div class="component-box">
    <form (ngSubmit)="onSearch()" class="search-form">
      <div class="search-fields">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Measurement</mat-label>
          <mat-select [(ngModel)]="searchForm.measurement" name="measurement" placeholder="Measurement">
            @for (measurement of measurements; track measurement) {
              <mat-option [value]="measurement">
                {{ measurement }}
              </mat-option>
            }
          </mat-select>
          @if (searchForm.measurement) {
            <button mat-icon-button matSuffix (click)="searchForm.measurement = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Country</mat-label>
          <mat-select [(ngModel)]="searchForm.country" name="country" placeholder="Country">
            @for (country of countries$ | async; track country.id) {
              <mat-option [value]="country.id">
                {{ country.name }}
              </mat-option>
            }
          </mat-select>
          @if (searchForm.country) {
            <button mat-icon-button matSuffix (click)="searchForm.country = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="searchForm.name" name="name" placeholder="Search by company name">
        </mat-form-field>
        <div class="checkbox-field">
          <mat-checkbox [(ngModel)]="searchForm.isActive" name="isActive">Is Active</mat-checkbox>
        </div>
        <div class="checkbox-field">
          <mat-checkbox [(ngModel)]="searchForm.isTransferred" name="isTransferred">Is Transferred</mat-checkbox>
        </div>
      </div>
      <div class="search-actions">
        <button mat-flat-button color="primary" type="submit">
          <mat-icon>search</mat-icon>
          Search
        </button>
        <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="clearSearch()">
          <mat-icon>clear</mat-icon>
          Clear
        </button>
      </div>
    </form>
  </div>
}
